export const NO_OFFERS = 'non-offers'
